import EmojiNeutral from './emoji_neutral.svg';
import EmojiSatisfied from './emoji_satisfied.svg';
import EmojiVerySatisfied from './emoji_very_satisfied.svg';
import EmojiDissatisfied from './emoji_dissatisfied.svg';
import EmojiVeryDissatisfied from './emoji_very_dissatisfied.svg';
import EmojiNeutralGrey from './emoji_neutral_grey.svg';
import EmojiSatisfiedGrey from './emoji_satisfied_grey.svg';
import EmojiVerySatisfiedGrey from './emoji_very_satisfied_grey.svg';
import EmojiDissatisfiedGrey from './emoji_dissatisfied_grey.svg';
import EmojiVeryDissatisfiedGrey from './emoji_very_dissatisfied_grey.svg';
import CheckboxFill from './checkbox_fill.svg';
import RadioFill from './radio_fill.svg';
import Today from './today.svg';
import TodayGrey from './today_grey.svg';

const styles = (theme) => ({
  root: {
    color: theme.palette.text.dark,
    fontFamily: 'Calibre',
    fontSize: '1.0625rem',
    textAlign: 'left',

    '& .list-inline-item': {
      marginRight: 0,
    },

    '& .btn-wizard-nav-previous': {
      marginRight: '8px',
    },

    '& .hr': {
      height: '1px',
      backgroundColor: '#DFDFDF',
      marginTop: '50px',
      marginBottom: '25px',
      position: 'relative',

      '&:after': {
        content: "''",
        position: 'absolute',
        borderStyle: 'solid',
        borderWidth: '15px 15px 0',
        borderColor: '#FFFFFF transparent',
        display: 'block',
        width: 0,
        zIndex: 1,
        left: 'calc(50% - 15px)',
      },

      '&:before': {
        content: "''",
        position: 'absolute',
        borderStyle: 'solid',
        borderWidth: '15px 15px 0',
        borderColor: '#7F7F7F transparent',
        display: 'block',
        width: 0,
        zIndex: 1,
        left: 'calc(50% - 15px)',
      },
    },

    '& .formio-errors': {
      display: 'block !important',

      '& .error': {
        color: '#d81118 !important',
      },
    },
    '& .form-group': {
      marginBottom: '1rem',
    },
    '& .form-check': {
      verticalAlign: 'top',
    },
    '& .pagination': {
      display: 'none',
    },

    '& input[type="text"], & input[type="number"]': {
      minHeight: 50,
      borderColor: theme.palette.border.field,
    },

    /* Common label styling */
    '& .formio-component > label': {
      marginBottom: theme.spacing.unit,
      width: '100%',
      textAlign: 'center',
      fontSize: '1.375rem',
      fontWeight: 600,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.625rem',
      },
    },

    /* Common radio and checkbox styling */
    '& .formio-component-selectboxes, & .formio-component-radio': {
      '& .form-check': {
        borderBottom: `1px solid ${theme.palette.border.lightest}`,
        paddingTop: theme.spacing.unit * 1.5,
        paddingBottom: theme.spacing.unit * 1.5,
        '&:first-child': {
          borderTop: `1px solid ${theme.palette.border.lightest}`,
        },
      },
    },

    /* Text area component */
    '& .formio-component-textarea': {
      '& textarea': {
        borderColor: theme.palette.border.field,
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 4,
        fontSize: '1.1875rem',
      },
    },

    /* Text field component */
    '& .formio-component-textfield': {
      '& input': {
        color: theme.palette.text.dark,
        fontSize: '1.125rem',
      },
    },

    /* Radio component */
    '& .formio-component-radio': {
      '& .form-check-input:checked[type=radio]': {
        backgroundColor: 'transparent',
        backgroundImage: `url('${RadioFill}')`,
        backgroundSize: '125%',
      },
    },

    /* Checkbox component */
    '& .formio-component-selectboxes': {
      '& .form-check-input': {
        borderRadius: 0,
        '&:checked[type=checkbox]': {
          backgroundColor: 'transparent',
          backgroundImage: `url('${CheckboxFill}')`,
          backgroundSize: '125%',
        },
      },
    },

    /* 'Button' component (radio base) */
    '& .formio-component-radio.button': {
      '& > label': {
        marginBottom: theme.spacing.unit * 5,
      },
      '& input': {
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
      },
      '& .form-radio': {
        display: 'flex',
      },
      '& .form-check': {
        flex: 1,
        border: 'none',
        padding: 0,
        '&:first-child': {
          border: 'none',
        },
        '&:first-of-type label': {
          borderRadius: `${theme.variables.borderRadius}px 0 0 ${theme.variables.borderRadius}px`,
        },
        '&:last-of-type label': {
          borderRadius: `0 ${theme.variables.borderRadius}px ${theme.variables.borderRadius}px 0`,
        },
      },
      '& .form-check label': {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        minHeight: 40,
        border: `1px solid ${theme.palette.primary.dark}`,
        fontSize: '1.1875rem',
        fontWeight: 500,
        textAlign: 'center',
        cursor: 'pointer',
        [theme.breakpoints.up('sm')]: {
          minHeight: 48,
        },
        '& span': {
          alignSelf: 'center',
        },
      },
      '& .radio-selected label': {
        color: 'white',
        background: theme.palette.primary.dark,
      },
    },

    /* Smiley component (radio base) */
    '& .formio-component-radio.smiley': {
      '& .form-radio': {
        textAlign: 'center',
      },
      '& input': {
        margin: 0,
        border: 'none',
        background: 'none',
        padding: 0,
        appearance: 'none',
        '&:focus': {
          boxShadow: 'none',
        },
        '&:checked[type=radio]': {
          background: 'none',
        },
      },
      '& .form-check': {
        display: 'inline-block',
        border: 'none',
        paddingLeft: 2,
        '&:first-child': {
          border: 'none',
          paddingLeft: 0,
        },
        '& label': {
          backgroundRepeat: 'no-repeat',
          width: 45,
          height: 45,
          backgroundSize: 'cover',
          cursor: 'pointer',
          [theme.breakpoints.up('sm')]: {
            width: 55,
            height: 55,
          },
          '& span': {
            display: 'none',
          },
        },
        '&:nth-child(1)': {
          '& label': {
            backgroundImage: `url('${EmojiVeryDissatisfiedGrey}')`,
          },
          '&.radio-selected label': {
            backgroundImage: `url('${EmojiVeryDissatisfied}')`,
          },
        },
        '&:nth-child(2)': {
          '& label': {
            backgroundImage: `url('${EmojiDissatisfiedGrey}')`,
          },
          '&.radio-selected label': {
            backgroundImage: `url('${EmojiDissatisfied}')`,
          },
        },
        '&:nth-child(3)': {
          '& label': {
            backgroundImage: `url('${EmojiNeutralGrey}')`,
          },
          '&.radio-selected label': {
            backgroundImage: `url('${EmojiNeutral}')`,
          },
        },
        '&:nth-child(4)': {
          '& label': {
            backgroundImage: `url('${EmojiSatisfiedGrey}')`,
          },
          '&.radio-selected label': {
            backgroundImage: `url('${EmojiSatisfied}')`,
          },
        },
        '&:nth-child(5)': {
          '& label': {
            backgroundImage: `url('${EmojiVerySatisfiedGrey}')`,
          },
          '&.radio-selected label': {
            backgroundImage: `url('${EmojiVerySatisfied}')`,
          },
        },
      },
    },

    /* Date and time picker component */
    '& .formio-component-datetime': {
      '& .input-group-append': {
        display: 'none',
      },
      '& input': {
        paddingLeft: 40,
        backgroundImage: `url('${Today}')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: `${theme.spacing.unit}px center`,
        '&:placeholder-shown': {
          backgroundImage: `url('${TodayGrey}')`,
        },
      },
      '& .form-control[readonly]': {
        backgroundColor: theme.palette.background.lighter,
      },
    },
    '&.flatpickr-calendar': {
      '& .flatpickr-months .flatpickr-month': {
        height: 55,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .flatpickr-current-month': {
          paddingTop: 0,
        },
      },
      '& .flatpickr-prev-month, & .flatpickr-next-month': {
        '&:hover svg': {
          background: theme.palette.primary.dark,
          fill: theme.palette.text.white,
        },
        '& svg': {
          border: `1px solid ${theme.palette.primary.dark}`,
          borderRadius: '50%',
          width: 30,
          height: 30,
          padding: 6,
        },
      },
      '& .flatpickr-day': {
        '&:not(.nextMonthDay)': {
          color: theme.palette.text.dark,
        },
        '&.today': {
          borderColor: theme.palette.primary.dark,
        },
        '&.selected': {
          background: theme.palette.primary.main,
        },
        '&:hover, &:focus': {
          background: theme.palette.primary.dark,
          color: theme.palette.primary.contrastText,
        },
      },
      '& .flatpickr-time': {
        height: 50,
        maxHeight: 50,
        '& .numInputWrapper': {
          height: 50,
          '& span': {
            border: 'none',
            opacity: 1,
          },
          '& .arrowUp:after': {
            borderBottomColor: theme.palette.primary.dark,
          },
          '& .arrowDown:after': {
            borderTopColor: theme.palette.primary.dark,
          },
        },
        '& .flatpickr-time-separator, & .flatpickr-am-pm': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        '& .flatpickr-time-separator': {
          marginTop: -theme.spacing.unit,
          marginLeft: theme.spacing.unit * 0.5,
        },
      },
    },

    /* HTML element component (e.g. paragraph) */
    '& .formio-component-htmlelement p, & .form-text': {
      color: `${theme.palette.text.dark} !important`,
      textAlign: 'center',
      fontSize: '1.0625rem',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.1875rem',
      },
    },

    /* Custom divider/hr component */

    /* Form navigation buttons */
    '& .formio-wizard-nav-container': {
      marginTop: 40,
    },
    '& .right-button-container': {
      display: 'inline-block',
      right: 0,
      position: 'absolute',
    },
    '& .btn-primary': {
      minHeight: 34,
      borderColor: theme.palette.primary.dark,
      padding: `${theme.spacing.unit * 0.5}px ${theme.spacing.unit * 2}px`,
      color: theme.palette.text.dark,
      background: theme.palette.background.lighter,
      fontSize: '1.0625rem',
      fontWeight: 500,
      [theme.breakpoints.up('sm')]: {
        minHeight: 40,
        paddingLeft: theme.spacing.unit * 5,
        paddingRight: theme.spacing.unit * 5,
        fontSize: '1.1875rem',
      },
      '&:hover': {
        background: theme.palette.primary.dark,
        color: theme.palette.text.white,
      },
      '&:disabled': {
        border: '1px solid rgba(0, 0, 0, 0.26)',
        color: 'rgba(0, 0, 0, 0.26)',
        '&:hover': {
          background: 'none',
          cursor: 'default',
        },
      },
    },

    /* Page count */
    '& .page-count': {
      textAlign: 'center',
      fontSize: '1.375rem',
      fontWeight: 600,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.625rem',
      },
    },

    '& .btn-wizard-nav-cancel': {
      display: 'none',
    },
  },
});

export default styles;
